import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./ServicePage.css";

const ServicePage = () => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);

  // Icon mapping theo service_type
  const iconMap = {
    massage: "💆‍♀️",
    giupviectainha: "🧹",
    nhomboxinghoctainha: "�",
    hocvotainha: "🥋",
    thozaysonluong: "�",
    daydanpianotainha: "🎹",
    thosuachuadiennuoc: "�",
  };

  const ITEMS_PER_PAGE = 8; // 2 hàng x 4 cột

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          "https://iudi-api.thinkdiff.us/api/get-providers"
        );

        if (response.ok) {
          const data = await response.json();
          if (data && data.providers && data.providers.length > 0) {
            setProviders(data.providers);
          }
        }
      } catch (error) {
        console.error("Lỗi tải dữ liệu:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  const totalPages = Math.ceil(providers.length / ITEMS_PER_PAGE);
  const startIndex = currentPage * ITEMS_PER_PAGE;
  const currentProviders = providers.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(price);
  };

  return (
    <div className="service-page">
      {/* Row 1 - Banner chính */}
      <div
        className="banner-section"
        style={{
          backgroundImage: `url('/images/nen-dich-vu.jpg')`,
        }}
      >
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-title">Học võ tại nhà</h1>
            <p className="banner-subtitle">
              Đặt ngay để nhận ưu đãi trong hôm nay
            </p>
            <button className="banner-button">ĐẶT NGAY</button>
          </div>
        </div>
      </div>

      {/* Row 2 - Danh mục dịch vụ */}
      <div className="services-section">
        <h2 className="services-title">Danh mục dịch vụ</h2>

        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Đang tải dịch vụ...</p>
          </div>
        ) : (
          <>
            <div className="services-slider-container">
              {/* Previous Button */}
              <button
                className="slider-btn slider-btn-prev"
                onClick={handlePrevious}
                disabled={currentPage === 0}
                aria-label="Trang trước"
              >
                ‹
              </button>

              {/* Services Grid */}
              <div className="services-grid">
                {currentProviders.map((provider) => (
                  <div key={provider.provider_id} className="service-card">
                    <div className="service-icon">
                      {iconMap[provider.service_type] || "🔧"}
                    </div>
                    <h3 className="service-name">{provider.name}</h3>
                    <p className="service-price">
                      {formatPrice(provider.price_per_hour)}/giờ
                    </p>
                    <div className="service-rating">
                      ⭐ {provider.rating} ({provider.total_ratings})
                    </div>
                    <p className="service-location">📍 {provider.address}</p>
                  </div>
                ))}
              </div>

              {/* Next Button */}
              <button
                className="slider-btn slider-btn-next"
                onClick={handleNext}
                disabled={currentPage === totalPages - 1}
                aria-label="Trang sau"
              >
                ›
              </button>
            </div>

            {/* Pagination Dots */}
            {totalPages > 1 && (
              <div className="pagination-dots">
                {Array.from({ length: totalPages }).map((_, index) => (
                  <button
                    key={index}
                    className={`dot ${index === currentPage ? "active" : ""}`}
                    onClick={() => setCurrentPage(index)}
                    aria-label={`Trang ${index + 1}`}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {/* Row 3 - Gợi ý đăng yêu cầu (CTA) */}
      <div
        className="suggestion-section cta-section"
        role="region"
        aria-labelledby="cta-heading"
        style={{ marginTop: 25 }}
      >
        <div className="suggestion-content">
          <h2 id="cta-heading" className="suggestion-title">
            Bạn muốn đăng yêu cầu?
          </h2>
          <p className="suggestion-subtitle">
            Tạo yêu cầu trống và tự chọn dịch vụ mong muốn
          </p>
          <button
            className="suggestion-button cta-button"
            aria-label="Đăng bài ngay"
            onClick={() => {
              /* handler nếu cần */
            }}
          >
            Đăng bài ngay
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServicePage;
